import styled from 'styled-components';

export const FormTitle = styled.div.attrs({})`
  color: ${(props) => props.theme.palette.primary.main};
  font-family: Kumbh Sans;
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
`;

export const ForgotLink = styled.div.attrs({})`
  margin-top: 6px;
  color: ${(props) => props.theme.palette.primary.main};
  cursor: pointer;
  font-family: Sora;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.64px;

  &:hover {
    text-decoration: underline;
  }
`;

export const RegisterContent = styled.div.attrs({})`
  background: ${(props) => props.theme.palette.colors.white};
  width: 100%;
  max-width: 436px;
  padding: 40px;
  border-radius: 8px;
  height: 100%;
  display: flex;
  gap: 16px;
  flex-direction: column;
  margin-top: 60px;
  @media (max-width: 767px) {
    padding: 20px;
  }
`;
